/* eslint-disable max-len */
import React, { SVGAttributes } from 'react';

export const MenuList = (props: SVGAttributes<unknown>): JSX.Element => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
    <rect width='24' height='24' fill='none' />
    <path
      d='M4 17.5C4 16.9477 4.44772 16.5 5 16.5H19C19.5523 16.5 20 16.9477 20 17.5C20 18.0523 19.5523 18.5 19 18.5H5C4.44772 18.5 4 18.0523 4 17.5Z'
      fill='currentColor'
    />
    <path
      d='M4 6.5C4 5.94772 4.44772 5.5 5 5.5H19C19.5523 5.5 20 5.94772 20 6.5C20 7.05228 19.5523 7.5 19 7.5H5C4.44772 7.5 4 7.05228 4 6.5Z'
      fill='currentColor'
    />
    <path
      d='M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z'
      fill='currentColor'
    />
  </svg>
);
